import { TabbedPage } from "../../components/TabbedPage";
import { ApprovalRequestsPage } from "../approvals/ApprovalRequestsPage";
import { ApprovalRulesPage } from "../approvals/ApprovalRulesPage";

/** Merged Approval Requests + Approval Rules — both gated identically
 * (ROLES_WITH_APPROVALS_ACCESS, permission-checked server-side), so no per-tab role
 * filtering is needed. */
export function ApprovalsPage() {
  return (
    <TabbedPage
      title="Approvals"
      defaultTab="requests"
      tabs={[
        { key: "requests", label: "Requests", content: <ApprovalRequestsPage /> },
        { key: "rules", label: "Rules", content: <ApprovalRulesPage /> },
      ]}
    />
  );
}
